module.exports = __webpack_public_path__ + "img/coatch-slider8-profile.d3a8b5d1.png";